import React, { useState } from "react";
import { Gift, Plus, Minus } from "lucide-react";
import { Button } from "../../../shadcn/ui/button";
import { Input } from "../../../shadcn/ui/input";
import { Badge } from "../../../shadcn/ui/badge";
import { isOrgAdmin } from "../../../utils/orgAdminAccess";

const AddOnCard = ({ pkg, formatCurrency, onPurchase, isLoading, currentUser }) => {
  const [quantity, setQuantity] = useState(1);
  const userIsOrgAdmin = isOrgAdmin(currentUser);

  const getAddOnFeatures = pkg => {
    const features = [];
    if (pkg.offers && pkg.offers.length > 0) {
      pkg.offers.forEach(offer => {
        if (offer.name) features.push(offer.name);
      });
    }
    if (features.length === 0) {
      features.push("One-time purchase");
      features.push("Instant activation");
    }
    return features.slice(0, 4);
  };

  const features = getAddOnFeatures(pkg);

  return (
    <div className="rounded-2xl p-6 shadow-sm border bg-white/90 backdrop-blur-sm border-purple-200 relative">
      <Badge className="absolute -top-3 right-4 bg-purple-600 text-white">
        <Gift className="w-3 h-3 mr-1" />
        Add-on
      </Badge>
      <div className="space-y-4 pt-4">
        <h3 className="text-lg font-semibold text-gray-900">{pkg.name}</h3>
        <p className="text-sm text-gray-600">{pkg.description || "Enhance your subscription"}</p>
        <div className="flex items-baseline justify-center gap-2">
          <span className="text-3xl font-bold text-purple-600">{formatCurrency(pkg.amount, pkg.currency)}</span>
          <span className="text-xs text-gray-500">one-time</span>
        </div>
        <div className="space-y-3">
          {features.map((feature, idx) => (
            <div key={idx} className="flex gap-3 items-center">
              <div className="flex flex-shrink-0 justify-center items-center w-5 h-5 rounded-full bg-purple-600">
                <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <span className="text-sm text-gray-700">{feature}</span>
            </div>
          ))}
        </div>
        <div className="flex items-center gap-2">
          <Button
            type="button"
            variant="outline"
            size="icon"
            className="h-8 w-8"
            onClick={() => setQuantity(Math.max(1, quantity - 1))}
            disabled={quantity <= 1}
          >
            <Minus className="w-3 h-3" />
          </Button>
          <Input
            type="number"
            min="1"
            value={quantity}
            onChange={e => setQuantity(Math.max(1, parseInt(e.target.value, 10) || 1))}
            className="h-8 text-center text-sm"
          />
          <Button
            type="button"
            variant="outline"
            size="icon"
            className="h-8 w-8"
            onClick={() => setQuantity(quantity + 1)}
          >
            <Plus className="w-3 h-3" />
          </Button>
        </div>
        <Button
          onClick={e => onPurchase(e, pkg.id, quantity)}
          disabled={isLoading}
          className="w-full bg-purple-600 hover:bg-purple-700 text-white"
        >
          {userIsOrgAdmin ? "Purchase Add-on" : "Contact Admin to Purchase"}
        </Button>
      </div>
    </div>
  );
};

export default AddOnCard;
